import LoadingIndicator from "@src/Components/LoadingIndicator"
import { useLocale } from "@src/Hooks/useLocale"
import { tState } from "@src/Model/Model"
import { inviteLinkSignupWatcher } from "@src/Sagas"
import * as React from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"

import C from "../../../Controller"
import MagicLinkSignUp from "./MagicLinkSignUp"

interface IInviteLinkNavParams {
  linkId: string
}

const OrgUserMagicLinkInviteSignup = () => {
  const app = document.getElementById("portal")
  const dispatch = useDispatch()
  const history = useHistory()
  const { linkId }: IInviteLinkNavParams = useParams()
  const { currentLocale } = useLocale()
  const recaptchaRef = React.createRef<ReCAPTCHA>()
  const [isLoadingCaptcha, setIsLoadingCaptcha] = React.useState(false)

  const { authenticated } = useSelector((store: tState) => store.portal)
  const { isLoading: getInviteLinkLoading, data } = useSelector(
    (store: tState) => store.account.getInviteLink,
  )
  const { isLoading: signupLoading } = useSelector(
    (store: tState) => store.account.inviteLinkSignup,
  )
  const onMagicLinkSignUp = (password: string) => {
    C.heapIdentify(data.createdFor?.email || "")
    dispatch(
      inviteLinkSignupWatcher({ linkId, password, locale: currentLocale }),
    )
  }

  const executeCaptcha = () => {
    setIsLoadingCaptcha(true)
    const current: any = recaptchaRef.current
    current.execute()
  }

  const resetCaptcha = () => {
    const current: any = recaptchaRef.current
    current.reset()
  }

  const verifyToken = (token: any, callback: any) => {
    C.Recaptcha.verifyToken(token, callback)
  }

  React.useEffect(() => {
    C.initEnvironment()
    C.Recaptcha.loadScriptv2() //Load Recaptcha v2
    C.Portal.checkSession()
  }, [])

  React.useEffect(() => {
    if (authenticated) {
      history.push("/")
    }
  }, [authenticated])

  if (authenticated === null || getInviteLinkLoading) {
    return <LoadingIndicator text="Loading Cyber Safety..." />
  }

  return (
    <MagicLinkSignUp
      data={data}
      height={app?.clientHeight || 0}
      onMagicLinkSignUp={onMagicLinkSignUp}
      recaptchaRef={recaptchaRef}
      executeCaptcha={executeCaptcha}
      verifyToken={verifyToken}
      resetCaptcha={resetCaptcha}
      setIsLoadingCaptcha={setIsLoadingCaptcha}
      isLoading={isLoadingCaptcha || signupLoading}
    />
  )
}

export default OrgUserMagicLinkInviteSignup
